import { render, staticRenderFns } from "./HistoryAppoint.vue?vue&type=template&id=2b0a1976&scoped=true&"
import script from "./HistoryAppoint.vue?vue&type=script&lang=js&"
export * from "./HistoryAppoint.vue?vue&type=script&lang=js&"
import style0 from "./HistoryAppoint.vue?vue&type=style&index=0&id=2b0a1976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a1976",
  null
  
)

export default component.exports